














import {Component, Prop, Vue} from "vue-property-decorator";
import {AzureEventHubEndpoint} from "../../types/core-push";

@Component
export default class AzureEventHubEndpointView extends Vue {
  @Prop({ default: {},  type: Object}) azureEventHubEndpoint!: AzureEventHubEndpoint;

  maskSecret(field:string|undefined): string|undefined {
    if(field === undefined)
      return field;

    if(field.length < 4)
      return '...';

    return field.replace(/SharedAccessKey=(.+)/, 'SharedAccessKey=***');
  }
}
